
<template>
  <div :class="containerClasses">
    <label
      v-if="label"
      :for="uniqid"
      class="Form-input__label"
    >
      {{ label }}
    </label>

    <div
      :class="{ 'Select-wrapper--small': small }"
      class="Select-wrapper"
    >
      <select
        :id="uniqid"
        :disabled="disabled"
        class="Select"
        @change="updateSelected($event)"
      >
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          :selected="value == option.value"
          class="Option"
        >
          {{ option.text }}
        </option>
      </select>
    </div>
    <p v-if="errorMessage" class="Form-input__error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import formInputMixin from './form-input-mixin'

export default {
  name: 'DropdownInput',
  mixins: [formInputMixin],
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    isAssociation: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateSelected (event) {
      this.$emit('touch')
      this.$emit('change', event)
      this.$emit('input', event.target.value)
    }
  }
}
</script>
